import React from 'react';
import { Navbar } from './Navbar';

export const ViewerNavbar: React.FC = () => <Navbar portal="viewer" />;
